/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../typography/Typography';

const AccordionBody = React.forwardRef((props, ref) => {
  const { children: childrenProp, ...other } = props;
  let children;
  if (typeof childrenProp === 'string') {
    children = <Typography>{childrenProp}</Typography>;
  } else {
    children = childrenProp;
  }

  return (
    <div
      ref={ref}
      className="sui-bg-primary sui-p-4"
      {...other}
    >
      {children}
    </div>
  );
});

AccordionBody.displayName = 'AccordionBody';

AccordionBody.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
};

export { AccordionBody };